import { createStyles } from "@mantine/styles";
import { HEADER_HEIGHT } from "../header/header.style";

export default createStyles((theme) => ({
    navbar: {
      paddingTop: 0,
      top: HEADER_HEIGHT,
      [theme.fn.smallerThan('md')]: {
        top: 0
      },
      height: "100%",
      overflow: "auto",
      backgroundColor: theme.colorScheme === "light" ? "white" : theme.colors.dark[9]
    },
  
    section: {
      marginLeft: -theme.spacing.lg,
      marginRight: -theme.spacing.lg,
      marginBottom: theme.spacing.xs,
    },

    lastSection: {
      marginLeft: -theme.spacing.lg,
      marginRight: -theme.spacing.lg,
    },
  
    searchCode: {
      fontWeight: 700,
      fontSize: 10,
      backgroundColor: theme.colors.gray[0],
      border: `1px solid ${
        theme.colors.gray[2]
      }`,
    },
  
    mainLinks: {
      paddingLeft: theme.spacing.md - theme.spacing.xs,
      paddingRight: theme.spacing.md - theme.spacing.xs,
      paddingBottom: theme.spacing.md,
    },
  
    mainLink: {
      display: 'flex',
      alignItems: 'center',
      width: '100%',
      fontSize: theme.fontSizes.xs,
      padding: `8px ${theme.spacing.xs}px`,
      borderRadius: theme.radius.sm,
      fontWeight: 500,
      color: theme.colors.gray[4],
  
    },
  
    mainLinkInner: {
      display: 'flex',
      alignItems: 'center',
      flex: 1,
    },
  
    mainLinkIcon: {
      marginRight: theme.spacing.sm,
      color: theme.colorScheme === 'dark' ? theme.colors.dark[2] : theme.colors.gray[6],
    },
  
    mainLinkBadge: {
      padding: 0,
      width: 20,
      height: 20,
      pointerEvents: 'none',
    },
  
    collections: {
      paddingLeft: theme.spacing.md - 6,
      paddingRight: theme.spacing.md - 6,
      paddingBottom: theme.spacing.md,
    },
  
    collectionsHeader: {
      paddingLeft: theme.spacing.md + 2,
      paddingRight: theme.spacing.md,
      marginBottom: 5,
    },
  
    collectionLink: {
      display: 'block',
      padding: `8px ${theme.spacing.xs}px`,
      textDecoration: 'none',
      borderRadius: theme.radius.sm,
      fontSize: theme.fontSizes.xs,
      color: theme.colorScheme === 'dark' ? theme.colors.dark[0] : theme.colors.gray[7],
      lineHeight: 1,
      fontWeight: 500,
  
      '&:hover': {
        backgroundColor: theme.colorScheme === 'dark' ? theme.colors.dark[6] : theme.colors.gray[0],
        color: theme.colorScheme === 'dark' ? theme.white : theme.black,
      },
    },
    collapse_button: {
      color: theme.colorScheme === 'dark' ? theme.colors.dark[0] : theme.black,
      [theme.fn.smallerThan('md')]: {
        display: 'none'
      },
      '&:hover': {
        backgroundColor: "transparent"
      },
    },
  }));
  